module.exports = __webpack_public_path__ + "static/working-girl-375df9e89b8f10d3936b6fcdf98d9828.png";